import React, { useEffect, useState } from "react";
import BasicDetailsFields from "../../../constants/DeliveryDrivers/BasicDetailsFields.json";
import Input from "sushiweb/InputTypes/Input";
import Textarea from "sushiweb/InputTypes/Textarea";
import {
  addMandatoryNestedKeys,
  getObjectsDifference,
  getPath,
  getReadableDateTime,
  isValNull,
  setNestedKeyValue,
} from "../../../utils";
import ImageUploader from "../../Common/ImageUploader";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import { useParams } from "react-router-dom";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserActions from "../../../store/actions/User";
import * as CarrierActions from "../../../store/actions/Carriers";
import * as DeliveryDriverActions from "../../../store/actions/DeliveryDrivers";
import * as CityActions from "../../../store/actions/City";
import * as ZoneActions from "../../../store/actions/Zone";
import * as LocalityActions from "../../../store/actions/Locality";
import ErrorMsgs from "../../../constants/Errors.json";
import OTPModalWithPhoneNumber from "../../Common/OTPModalWithPhoneNumber";
import ErrorModal from "../../Common/ErrorModal";
import moment from "moment";
import { handleValidations, nestedMandatoryKey } from "../utils";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import {
  FieldsContainer,
  FieldsSection,
} from "../../../constants/assets/containers";
import {
  getActiveAppRelease,
  getAppReleasesList,
} from "../../../store/actions/DriverAppReleases";
import {getDashboardUrl} from "../../../views/Home"

const DriverBasicDetails = ({
  editState,
  details,
  activeLifecycleStatus,
  carriersList,
  getCarriersList,
  saveState,
  setSaveState,
  updateDriverBasicDetails,
  setStatus,
  getOTPDriverBasicDetails,
  driverVerifyPhoneNumberChange,
  cityList,
  localityList,
  getCityList,
  getLocalityList,
  getCarrierModels,
  carrierModels,
  handleDocumentDetails,
  driverDocuments,
  getDriverFinancialDetails,
  driverFinancialDetails,
  allMenuActions,
  nextPageCity,
  nextPageLocality,
  getCity,
  getLocality,
  zoneList,
  getZoneList,
  nextPageZone,
  getZone,
  getAppVersionsList,
  nextPageAppVersion,
  appVersionsList,
  getActiveAppRelease,
}) => {
  const { id } = useParams();
  const [initialState, setInitialState] = useState({});
  const [otpModal, setOtpModal] = useState(false);
  const [updatedPhoneNo, setUpdatedPhoneNo] = useState("");
  const [zonePriorityFlag, setZonePriorityFlag] = useState(false);
  const [localityPriorityFlag, setLocalityPriorityFlag] = useState(false);
  const [errors, setErrors] = useState([]);
  const onboardingOrSuspended =
    activeLifecycleStatus === "onboarding" ||
    activeLifecycleStatus === "suspended";

  const getValue = (field) => {
    if (field.key === "driver_tags") {
      const driverTagsPresent =
        initialState["driver_tags"] && initialState["driver_tags"].length > 0;
      return driverTagsPresent
        ? JSON.stringify(
            initialState["driver_tags"].map((item) => item.tag.name)
          )
        : "";
    }

    if (field.key === "polygon_ids") {
      const polygonIdsPresent =
        initialState["polygon_ids"] && initialState["polygon_ids"].length > 0;
      return polygonIdsPresent
        ? JSON.stringify(initialState["polygon_ids"])
        : "";
    }
    
    if (field.key === "image") {
      return getPath(driverDocuments, "image.expiring_url", "");
    }
    if (field.dateField) {
      return getReadableDateTime(getPath(initialState, field.key, ""));
    } else return getPath(initialState, field.key, "");
  };

  const getFieldOptions = (field) => {
    if (field.options.length > 0) {
      return field.options;
    }
    switch (field.key) {
      case "carrier_id":
        return carriersList;
      case "city_id":
        return cityList;
      case "zone_id":
        return zoneList;
      case "locality_id":
        return localityList;
      case "vehicle_details.vehicle_model_id":
        return carrierModels;
    }
  };

  //will call dependent apis on this variable change
  const callDependentApis = (key, val) => {
    if (key === "carrier_id" && !isValNull(val)) {
      getCarrierModels(val);
    }
  };

  const handleChange = (key, val, isNumber, isDateField) => {
    const values = { ...initialState };
    let finalVal = val;
    if (isNumber === true && finalVal) {
      finalVal = parseInt(finalVal);
    }
    if (isDateField === true && finalVal) {
      finalVal = moment.utc(finalVal.toLocaleString()).format();
    }
    if (key === "city_id") {
      // if (details.zone_enabled) {
      setNestedKeyValue(values, "zone_id", "");
      setZonePriorityFlag(true);
      // }
      if (getPath(values, "locality_id", undefined)) {
        setNestedKeyValue(values, "locality_id", "");
      }
      setLocalityPriorityFlag(true);
    } else if (key === "zone_id") {
      setZonePriorityFlag(false);
      setNestedKeyValue(values, "locality_id", "");
      setLocalityPriorityFlag(true);
    } else if (key === "locality_id") {
      setLocalityPriorityFlag(false);
    }
    callDependentApis(key, finalVal);
    setNestedKeyValue(values, key, finalVal);
    setInitialState(values);
  };

  const getDropdownVal = (value, options, field) => {
    const selectedOption = options.find(
      (item) => item[field.valueKey] === value
    );
    return field && selectedOption && selectedOption[field.labelKey];
  };

  //update api and otp flow
  const updateDriverDetailsFunc = (payload) => {
    const values = { ...payload };
    if (
      !getPath(details, "zone_enabled", false) &&
      isValNull(initialState.zone_id)
    ) {
      delete values["zone_id"];
    }
    updateDriverBasicDetails(id, values, initialState).then((res) => {
      if (res) {
        if (getPath(res, "status.code", undefined) === 897) {
          setUpdatedPhoneNo("");
          setStatus({
            type: "error",
            message: ErrorMsgs.OTP_REQUIRED,
          });
          setOtpModal(true); //show otp modal and make getotp call
          setTimeout(
            () =>
              getOTPDriverBasicDetails(id, values).then((res) =>
                setUpdatedPhoneNo(getPath(res, "OTP.sent_to", undefined))
              ),
            1000
          );
        }
      }
    });
  };

  //roll back to initialstate if update phone no failed
  const rollBackState = () => {
    const activeDetailsCopy = JSON.parse(JSON.stringify(details));
    setInitialState(activeDetailsCopy);
  };

  const handleSubmit = () => {
    let mandatoryFieldsType = onboardingOrSuspended
      ? "basicDetailsOnboarding"
      : "basicDetails";
    const payload = getObjectsDifference(details, initialState, "id");
    addMandatoryNestedKeys(payload, initialState, nestedMandatoryKey);
    console.log("payload", payload);
    const validationErrors = handleValidations(
      initialState,
      mandatoryFieldsType,
      initialState,
      driverFinancialDetails
    );
    if (Object.keys(payload).length > 0 && validationErrors.length === 0) {
      if (payload.phone_no) {
        driverVerifyPhoneNumberChange(id, payload.phone_no).then((res) => {
          if (res) {
            updateDriverDetailsFunc(payload);
          } else {
            rollBackState();
          }
        });
      } else {
        updateDriverDetailsFunc(payload);
      }
    } else if (Object.keys(payload).length === 0) {
      if (validationErrors.length > 0) {
        setErrors(validationErrors);
      } else {
        const err = [...errors];
        err.push("Error! You didn't make any change");
        setErrors(err);
      }
    } else {
      setErrors(validationErrors);
    }
    setSaveState(false);
  };

  const handleImageEdit = () => {
    handleDocumentDetails();
  };

  const handleNextPage = async (existingList) => {
    let result = existingList;
    const pageRequest = {
      page: nextPageAppVersion,
    };
    await getAppVersionsList({}, pageRequest).then((res) => {
      if (res && res.driver_app_releases) {
        result = [...result, ...res.driver_app_releases];
      }
    });
    return result;
  };

  const getField = (type, field) => {
    switch (type) {
      case "text":
        return (
          <Input
            id="sushi-input"
            data-testid={field.id}
            fullWidth={true}
            disabled={
              (editState && field.disabled) ||
              (onboardingOrSuspended &&
                editState &&
                field.disabledWhileOnBoarding)
            }
            onChange={(e) => handleChange(field.key, e, field.isNumber)}
            value={getValue(field)}
          />
        );
      case "textarea":
        return (
          <Textarea
            id="sushi-textarea"
            data-testid={field.id}
            fullWidth={true}
            disabled={editState && field.disabled}
            onChange={(e) => handleChange(field.key, e, field.isNumber)}
            value={getValue(field)}
          />
        );
      case "calender":
        return (
          <Input
            id="sushi-input"
            className="calender-input"
            data-testid={field.id}
            fullWidth={true}
            disabled={editState && field.disabled}
            onChange={(e) => handleChange(field.key, e)}
            value={moment(getPath(initialState, field.key, "")).format(
              "YYYY-MM-DD"
            )}
            type="date"
            onChange={(val) =>
              handleChange(field.key, val, field.isNumber, field.dateField)
            }
          />
        );
      case "image":
        return (
          <ImageUploader
            id="driver-image"
            handleImageClick={handleImageEdit}
            //   handleImageChange={handleImageChange}
            // state={editState ? "Edit" : ""}
            imageKey={"image"}
            activeItem={initialState}
            imageUrl={getValue(field)}
            //   uploadUrl="/training-dashboard/upload-course-thumbnail"
            //   callback_key={callback_key}
            //   presign_url={presign_url}
            //   keyName="callback_key"
            //   handleImageUrlChange={handleImageUrlChange}
            noAckCall
          />
        );
      case "dropdown":
        return (
          <PaginatedReactDropdown
            options={getFieldOptions(field)}
            disabled={
              (editState && field.disabled) ||
              (field.permission_edit && !allMenuActions[field.permission_edit])
            }
            labelKey={field.labelKey}
            valueKey={field.valueKey}
            value={getDropdownVal(
              getPath(initialState, field.key, ""),
              getFieldOptions(field),
              field
            )}
            handleChange={handleChange}
            placeholder=""
            keyToChange={field.key}
            showCross={true}
            id={`driverBasicDetailsDropdown${field.labelKey}`}
          />
        );
      case "app-version-dropdown":
        return (
          <InfiniteScrollDropdown
            id="AppVersionDropdown"
            className="sushi-dropdown"
            priorityFlag={true}
            appliedFilters={{ show_on_driver_edit: true }}
            getActiveList={getAppVersionsList}
            nextPage={nextPageAppVersion}
            resKey="releases"
            // modalState="Edit"
            keyName="expected_app_version"
            labelKey="version"
            // value={{version:getPath(details, field.key, "")}}
            defaultVal={{ version: getPath(initialState, field.key, "") }}
            // getDataLabelKey="city.city_name"
            keyTypeToSet="version"
            label=""
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="starts_with"
            getActiveItemById={getActiveAppRelease}
            activeElement={initialState}
            allowDuplicateOptions
            // getActiveItemById={getCity}
          />
        );
      case "city-dropdown":
        return (
          <div
            onClick={() => handleRedirection(field)}
            className="city-val w-full"
          >
            <InfiniteScrollDropdown
              id="cityDetailDropdown"
              className="sushi-dropdown"
              priorityFlag={true}
              appliedFilters={{}}
              getActiveList={getCityList}
              nextPage={nextPageCity}
              resKey="cities"
              modalState="Edit"
              keyName="city_id"
              labelKey="city_name"
              getDataLabelKey="city.city_name"
              keyTypeToSet="id"
              label=""
              handleChange={handleChange}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
              activeElement={initialState}
              getActiveItemById={getCity}
            />
          </div>
        );
      case "zone-dropdown":
        return (
          <div
            onClick={() => handleRedirection(field)}
            className="zone-val w-full"
          >
            <InfiniteScrollDropdown
              id="zoneDetailDropdown"
              className="sushi-dropdown"
              priorityFlag={zonePriorityFlag}
              setPriorityFlag={setZonePriorityFlag}
              appliedFilters={
                initialState && initialState.city_id
                  ? { city_id: initialState.city_id }
                  : {}
              }
              getActiveList={getZoneList}
              nextPage={nextPageZone}
              resKey="zones"
              modalState="Edit"
              keyName="zone_id"
              labelKey="zone_name"
              getDataLabelKey="zone.zone_name"
              keyTypeToSet="id"
              label=""
              handleChange={handleChange}
              showCross={details.zone_enabled}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
              activeElement={initialState}
              getActiveItemById={getZone}
            />
          </div>
        );
      case "locality-dropdown":
        return (
          <div
            onClick={() => handleRedirection(field)}
            className="locality-val w-full"
          >
            <InfiniteScrollDropdown
              id="localityFilterDropdown"
              className="sushi-dropdown"
              priorityFlag={localityPriorityFlag}
              setPriorityFlag={setLocalityPriorityFlag}
              appliedFilters={
                initialState &&
                initialState[
                  !isValNull(initialState["zone_id"]) ? "zone_id" : "city_id"
                ]
                  ? !isValNull(initialState["zone_id"])
                    ? { zone_id: initialState.zone_id }
                    : { city_id: initialState.city_id }
                  : {}
              }
              getActiveList={getLocalityList}
              nextPage={nextPageLocality}
              resKey="localities"
              modalState="Edit"
              keyName="locality_id"
              labelKey="locality_name"
              getDataLabelKey="locality.locality_name"
              keyTypeToSet="id"
              label=""
              handleChange={handleChange}
              remoteSearchApplicable={true}
              remoteSearchKey="startswith"
              activeElement={initialState}
              getActiveItemById={getLocality}
            />
          </div>
        );
    }
  };

  const handleShowFields = (type, field) => {
    // if (field.key === "zone_id" && !details.zone_enabled) {
    //   return;
    // }
    return getField(type, field);
  };

  const handleCloseOTPModal = () => {
    setOtpModal(false);
  };

  const handleOTPVerify = (otp) => {
    //make update call with otp
    const payload = getObjectsDifference(details, initialState, "id");
    addMandatoryNestedKeys(payload, initialState, nestedMandatoryKey);
    if (
      !getPath(details, "zone_enabled", false) &&
      isValNull(initialState.zone_id)
    ) {
      delete payload["zone_id"];
    }
    updateDriverBasicDetails(id, payload, initialState, otp).then((res) => {
      if (res) {
        handleCloseOTPModal();
        setSaveState(false);
        setUpdatedPhoneNo("");
      }
    });
  };

  const getOTP = () => {
    // make post call to get otp
    const payload = getObjectsDifference(details, initialState, "id");
    addMandatoryNestedKeys(payload, initialState, nestedMandatoryKey);
    getOTPDriverBasicDetails(id, payload, true);
  };

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  const handleRedirection = (item) => {
    if (!editState) {
      if (item.key === "city_id") {
        const val = initialState["city_id"];
        if (!isValNull(val)) {
          window.open(window.location.origin + `/cities/${val}`, "_blank");
        }
      } else if (item.key === "zone_id") {
        const val = initialState["zone_id"];
        if (!isValNull(val)) {
          window.open(
            getDashboardUrl() + `/admin/zones/${val}`,
            "_blank"
          );
        }
      } else if (item.key === "locality_id") {
        const val = initialState["locality_id"];
        if (!isValNull(val)) {
          window.open(window.location.origin + `/localities/${val}`, "_blank");
        }
      }
    }
  };

  const checkIfFieldMandatory = (field) => {
    if (field.key === "zone_id") {
      return details.zone_enabled;
    }
    return field.isMandatory;
  };

  useEffect(() => {
    carriersList.length === 0 && getCarriersList();
    cityList.length === 0 && getCityList();
    zoneList.length === 0 && getZoneList();
    localityList.length === 0 && getLocalityList();
    const pageRequest = {
      page: 1,
    };
    getAppVersionsList({}, pageRequest);
    if (Object.keys(driverFinancialDetails).length === 0) {
      allMenuActions["DRIVER_FINANCIAL_DETAILS_VIEW"] &&
        getDriverFinancialDetails(id);
    }
  }, []);

  useEffect(() => {
    const activeDetailsCopy = JSON.parse(JSON.stringify(details));
    const carrierId = activeDetailsCopy.carrier_id;
    carrierId !== undefined && getCarrierModels(carrierId);
    // details.zone_enabled &&
    setZonePriorityFlag(true);
    setLocalityPriorityFlag(true);
    setInitialState(activeDetailsCopy);
  }, [details]);

  //to handle click on save button
  useEffect(() => {
    saveState && handleSubmit();
  }, [saveState]);

  //to handle click on cancel button
  useEffect(() => {
    !editState && rollBackState();
  }, [editState]);

  return (
    <DriverBasicDetailsContainer
      editState={editState}
      className={!editState && "no-edit"}
    >
      {Object.keys(initialState).length > 0 &&
        BasicDetailsFields.sections.map((section, index) => {
          return (
            <FieldsSection key={index}>
              {section.name && <p>{section.name}</p>}
              <FieldsContainer>
                {section.fields.map((field, fieldIdx) => {
                  if (field.hideWhenNull && isValNull(getValue(field))) {
                    return null;
                  }
                  return (
                    <FieldHolder
                      key={fieldIdx}
                      noBorder={field.noBorder}
                      justify="flex-start"
                    >
                      {field.placeholder && (
                        <span className="flex items-center flex-start">
                          {field.placeholder}
                          {checkIfFieldMandatory(field) && <sup>*</sup>}
                        </span>
                      )}
                      {field.permissions
                        ? allMenuActions[field.permissions]
                          ? handleShowFields(field.type, field)
                          : ""
                        : handleShowFields(field.type, field)}
                    </FieldHolder>
                  );
                })}
              </FieldsContainer>
            </FieldsSection>
          );
        })}
      {otpModal && (
        <OTPModalWithPhoneNumber
          handleOTPVerify={handleOTPVerify}
          getOTP={getOTP}
          handleClose={handleCloseOTPModal}
          heading="Verify OTP to update details"
          phone={updatedPhoneNo}
        />
      )}
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </DriverBasicDetailsContainer>
  );
};

function mapStateToProps(state) {
  const {
    Carriers,
    City,
    Locality,
    DeliveryDrivers,
    MenuActions,
    Zone,
    DriverAppReleases,
  } = state;
  return {
    carriersList: Carriers.carriersList,
    cityList: City.cityList,
    localityList: Locality.localityList,
    carrierModels: Carriers.carrierModels,
    driverFinancialDetails: DeliveryDrivers.driverFinancialDetails,
    allMenuActions: MenuActions.allMenuActions,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
    zoneList: Zone.zoneList,
    nextPageZone: Zone.nextPage,
    appVersionsList: DriverAppReleases.appReleasesList,
    nextPageAppVersion: DriverAppReleases.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverFinancialDetails: bindActionCreators(
      DeliveryDriverActions.getDriverFinancialDetails,
      dispatch
    ),
    getCarriersList: bindActionCreators(
      CarrierActions.getCarriersList,
      dispatch
    ),
    getCarrierModels: bindActionCreators(
      CarrierActions.getCarrierModels,
      dispatch
    ),
    updateDriverBasicDetails: bindActionCreators(
      DeliveryDriverActions.updateDriverBasicDetails,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getOTPDriverBasicDetails: bindActionCreators(
      DeliveryDriverActions.getOTPDriverBasicDetails,
      dispatch
    ),
    driverVerifyPhoneNumberChange: bindActionCreators(
      DeliveryDriverActions.driverVerifyPhoneNumberChange,
      dispatch
    ),
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    getCity: bindActionCreators(CityActions.getCity, dispatch),
    getLocality: bindActionCreators(LocalityActions.getLocality, dispatch),
    getZoneList: bindActionCreators(ZoneActions.getZoneList, dispatch),
    getZone: bindActionCreators(ZoneActions.getZone, dispatch),
    getAppVersionsList: bindActionCreators(getAppReleasesList, dispatch),
    getActiveAppRelease: bindActionCreators(getActiveAppRelease, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverBasicDetails);
